import { useReducer } from 'react'
import { toLower } from 'ramda'
import effects from 'app/effects/effects'
import {
  METERS_ID,
  METERS_TO_METERS,
  FEET_ID,
  METERS_TO_YARDS,
  YARDS_ID,
  METERS_TO_FEET,
  BEACON_LIMIT,
  OPEN_SPACE_ID,
  SMALL_ROOM_ID,
  MEDIUM_ROOM_ID,
  LARGE_ROOM_ID,
  rangeOfBeacon,
  RANGE_3_INDEX,
  RANGE_5_INDEX,
  RANGE_7_INDEX,
  RANGE_8_INDEX,
} from 'app/constants/beacon'

export const getProximityLength = (formatMessage) => {
  return [
    {
      id: METERS_ID,
      text: formatMessage({ id: 'compose.message.meter.unit' }),
      shortName: 'm',
      convert: METERS_TO_METERS,
    },
    {
      id: FEET_ID,
      text: formatMessage({ id: 'compose.message.feet.unit' }),
      shortName: 'ft',
      convert: METERS_TO_YARDS,
    },
    {
      id: YARDS_ID,
      text: formatMessage({ id: 'compose.message.yard.unit' }),
      shortName: 'yd',
      convert: METERS_TO_FEET,
    },
  ]
}

export const getRangeOptions = (unitId = 1, formatMessage) => {
  const proximityLengthOptions = getProximityLength(formatMessage)

  const proximity = proximityLengthOptions.find(
    (item) => parseInt(item.id) === parseInt(unitId),
  )

  const rangeWithUnit = rangeOfBeacon[proximity.shortName]

  return [
    {
      id: SMALL_ROOM_ID,
      text: `${formatMessage({ id: 'compose.message.roomsize.smallroom.label' })} (1 - ${rangeWithUnit[RANGE_3_INDEX - 1]} ${toLower(proximity.text)})`,
    },
    {
      id: MEDIUM_ROOM_ID,
      text: `${formatMessage({ id: 'compose.message.roomsize.mediumroom.label' })} (1 - ${rangeWithUnit[RANGE_5_INDEX - 1]} ${toLower(proximity.text)})`,
    },
    {
      id: LARGE_ROOM_ID,
      text: `${formatMessage({ id: 'compose.message.roomsize.largeroom.label' })} (1 - ${rangeWithUnit[RANGE_7_INDEX - 1]} ${toLower(proximity.text)})`,
    },
    {
      id: OPEN_SPACE_ID,
      text: `${formatMessage({ id: 'compose.message.roomsize.openspace.label' })} (1 - ${rangeWithUnit[RANGE_8_INDEX - 1]} ${toLower(proximity.text)})`,
    },
  ]
}

export const getUnitText = (unitId = 1, formatMessage) => {
  const proximityLengthOptions = getProximityLength(formatMessage)
  return proximityLengthOptions.find(
    (item) => parseInt(item.id) === parseInt(unitId),
  ).text
}

export const getUnitShortName = (unitId = 1, formatMessage) => {
  const proximityLengthOptions = getProximityLength(formatMessage)

  return proximityLengthOptions.find(
    (item) => parseInt(item.id) === parseInt(unitId),
  ).shortName
}

const initialState = {
  beacons: [],
  isLoading: false,
  error: undefined,
}

export const ActionType = {
  FETCH_START: 'FETCH_START',
  FETCH_SUCCESS: 'FETCH_SUCCESS',
  FETCH_ERROR: 'FETCH_ERROR',
}

const reducer = (state, action) => {
  switch (action.type) {
    case ActionType.FETCH_START:
      return {
        ...state,
        isLoading: true,
      }
    case ActionType.FETCH_SUCCESS:
      return {
        ...state,
        beacons: action.payload,
        isLoading: false,
        error: undefined,
      }
    case ActionType.FETCH_ERROR:
      return {
        ...state,
        beacons: [],
        isLoading: false,
        error: action.payload,
      }

    default:
      throw new Error('Not supported action')
  }
}

export const useBeacon = () => {
  const [state, dispatch] = useReducer(reducer, initialState)

  const fetchBeacons = () => {
    dispatch({ type: ActionType.FETCH_START })
    effects.apis
      .getBeacons({ limit: BEACON_LIMIT })
      .then((response) => {
        dispatch({ type: ActionType.FETCH_SUCCESS, payload: response.data })
      })
      .catch((error) => {
        dispatch({ type: ActionType.FETCH_ERROR, payload: error })
      })
  }

  return { state, fetchBeacons }
}
